import type { DeviationType, MavReportingRole } from "types/materialCase";

export const MAV_REPORTING_ROLES = [
  "WarehousePurchasing",
  "Production",
] as const satisfies readonly MavReportingRole[];

// Exact strings from AVVIKELSETYP_VALUES — kept assignable to DeviationType so a typo is a
// compile error (see DEM-098 techspec).
export const MAV_DEVIATION_TYPES: Record<
  MavReportingRole,
  readonly DeviationType[]
> = {
  WarehousePurchasing: [
    "Leverans av fel vara/tjänst",
    "Levererad mängd stämmer inte med beställning",
    "Levererad mängd stämmer inte med följesedel",
    "Levererat gods är skadat",
    "Kravdokumentation saknas eller är inte komplett",
  ],
  Production: [
    "Vara är trasig eller fungerar inte",
    "Vara stämmer inte med ritning/specifikation",
    "Övrigt",
  ],
};

export const MAV_VARIANT_ROUTES: Record<MavReportingRole, string> = {
  WarehousePurchasing: "/material/new/mav/lager",
  Production: "/material/new/mav/produktion",
};
